import { GoogleAdsAdAccountDTO } from 'api-models'
import { PlatformIcon } from 'components/platform-icon'
import { adAccountLabel } from 'utils/ad-account-label'

/**
 * Small GAds account identity card used in Setup (§3). Figma 6527:78713 —
 * icon + name (16px) + account number (14px), 546px wide, no status badge.
 */
export const AccountCard = ({
	adAccount
}: {
	adAccount: GoogleAdsAdAccountDTO
}) => {
	const title = adAccountLabel(adAccount)
	const accountNumber = adAccount.details?.account_number
	// When the account has no name the title already IS the number (see
	// adAccountLabel), and printing it twice reads as a rendering bug.
	const showNumber = Boolean(accountNumber) && accountNumber !== title

	return (
		<div className="flex w-[546px] max-w-full items-center gap-3 rounded-xl border border-t-checkbox bg-white p-4">
			<PlatformIcon platform="GADS" className="h-6 w-6 shrink-0" />
			<div className="min-w-0">
				<div className="truncate text-[16px] leading-[22px] text-t-coupon">
					{title}
				</div>
				{showNumber && (
					<div className="text-[14px] leading-[18px] text-t-gray-hold">
						{accountNumber}
					</div>
				)}
			</div>
		</div>
	)
}
